/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { ApplicationStage } from './ApplicationStage'
import {
  ApplicationStageFromJSON,
  ApplicationStageFromJSONTyped,
  ApplicationStageToJSON,
} from './ApplicationStage'

/**
 *
 * @export
 * @interface UpdateDataFirstStage200ResponseData
 */
export interface UpdateDataFirstStage200ResponseData {
  /**
   * Следующая стадия создания
   * @type {ApplicationStage}
   * @memberof UpdateDataFirstStage200ResponseData
   */
  nextStage: ApplicationStage
}

/**
 * Check if a given object implements the UpdateDataFirstStage200ResponseData interface.
 */
export function instanceOfUpdateDataFirstStage200ResponseData(
  value: object
): value is UpdateDataFirstStage200ResponseData {
  if (!('nextStage' in value) || value['nextStage'] === undefined) return false
  return true
}

export function UpdateDataFirstStage200ResponseDataFromJSON(
  json: any
): UpdateDataFirstStage200ResponseData {
  return UpdateDataFirstStage200ResponseDataFromJSONTyped(json, false)
}

export function UpdateDataFirstStage200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateDataFirstStage200ResponseData {
  if (json == null) {
    return json
  }
  return {
    nextStage: ApplicationStageFromJSON(json['nextStage']),
  }
}

export function UpdateDataFirstStage200ResponseDataToJSON(
  value?: UpdateDataFirstStage200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    nextStage: ApplicationStageToJSON(value['nextStage']),
  }
}
